const baseGeneralUrl = "General"


  const endpoints = {
   getFeedbackCategoryList:`${baseGeneralUrl}/GetFeedbackCategoryList`,
   getFeedbackListByUser:`${baseGeneralUrl}/GetFeedbackListByUser`,
  addFeedbackByUser:`${baseGeneralUrl}/AddFeedbackByUser`,
  addMediaByFeedback:`${baseGeneralUrl}/AddMediaByFeedback`,
   
   
  };
  
  export default endpoints;
  